import { MoveRight } from "lucide-react";
import moment from "moment";
import Lucide from "src/base-components/Lucide";
import { Flight } from "src/interfaces";

const FlightCard: React.FC<{ flight: Flight, index: number }> = ({ flight, index }) => {
    return (
        <div className="border-b-2 border-dashed   p-6 mt-6">
            <div className="flex justify-between items-center mb-5">
                <div className="flex items-center justify-start gap-4">

                    <div>
                        <h2 className="text-xl font-semibold text-gray-800">AIRLINE: {flight.airLineName}</h2>
                        <h2 className="text-xl font-semibold text-gray-800">{index === 0 ? '(Outbound)' : '(Inbound)'}</h2>
                    </div>
                </div>
                <div className="text-right">
                    {/* <p className="text-lg font-bold text-gray-800">{flight.totalPrice} {flight.currency}</p> */}
                    <p className="text-gray-500 text-sm">Total Duration: {flight.duration}</p>
                    <p className="text-sm text-gray-500"> {flight.stopLabel}</p>

                </div>
            </div>

            <div className="flex flex-row justify-between w-full items-center mb-5 border-b-4 pb-5">


                <div className="flex flex-col gap-2 justify-start w-[45%]">
                    <p className="text-gray-600 font-bold text-lg">{flight.departureAirport} </p>

                    <p className="text-sm text-primary flex flex-row items-center"><Lucide icon="Timer" className="mr-1 w-4 h-4 text-black" />Departure: {moment(flight.departureDate).format("DD MMM YYYY")} @{" "}
                        {moment(flight.departureDate).format("hh:mm A")}</p>
                </div>
                <MoveRight />

                <div className="flex flex-col gap-2 justify-start w-[45%]">
                    <p className="text-gray-600 font-bold text-lg">{flight.arrivalAirport}</p>

                    <p className="text-sm text-primary flex flex-row items-center"><Lucide icon="Timer" className="mr-1 w-4 h-4 text-black" />Arrival: {moment(flight.arrivalDate).format("DD MMM YYYY")} @{" "}
                        {moment(flight.arrivalDate).format("hh:mm A")}</p>
                </div>
                {/* <p className="text-sm text-gray-500">  <Lucide icon="Timer" className="mr-1 w-4 h-4 text-black" /> Departure: {new Date(flight.departureDate).toLocaleString()}</p>
                <p className="text-sm text-gray-500">  <Lucide icon="Timer" className="mr-1 w-4 h-4 text-black" /> Arrival: {new Date(flight.arrivalDate).toLocaleString()}</p> */}
            </div>

            <div className="mt-6 ">
                {flight.segments.map((segment, index) => (
                    <div key={index}>
                        {/* Render layover card if there's a layover */}
                        {segment.layoverTime && (
                            <div className="border-b border-dashed mb-4 flex items-center justify-center">
                                <p className=" text-gray-600 text-sm font-bold pb-3">Layover Time: {segment.layoverTime}</p>
                            </div>
                        )}
                        {/* Render segment card */}

                        <div className="p-1 rounded-lg mb-4 border-b border-dashed  ">
                            <div className="flex flex-row justify-between items-center">

                                <div className="flex flex-col gap-2 justify-start w-[42%]">
                                    <p className="text-sm font-semibold text-nowrap">{segment.departureAirport}</p>
                                    <p className="text-sm text-primary flex flex-row items-center justify-start">   <Lucide icon="Timer" className="mr-1 w-4 h-4 text-black" />Departure: {moment(segment.departureDate).format("DD MMM YYYY")} @{" "}
                                        {moment(segment.departureDate).format("hh:mm A")}
                                    </p>
                                </div>
                                <p className="flex flex-col justify-center items-center"><MoveRight />{segment.duration}</p>
                                <div className="flex flex-col gap-2 justify-start w-[42%] ">
                                    <p className="text-sm font-semibold text-nowrap">{segment.arrivalAirport}</p>
                                    <p className="text-sm text-primary flex flex-row items-center justify-start">   <Lucide icon="Timer" className="mr-1 w-4 h-4 text-black" />Departure: {moment(segment.arrivalDate).format("DD MMM YYYY")} @{" "}
                                        {moment(segment.arrivalDate).format("hh:mm A")}
                                    </p>
                                </div>
                            </div>
                            <div className="p-2 flex items-center gap-3 flex-row   ">

                                <img className="w-8 h-8 object-contain" src={segment.logo} alt={segment.carrierCode} />
                                <p className=" text-gray-600 text-sm font-bold">{segment.carrierCode} {segment.flightNumber}</p>
                            </div>

                            {/* {segment.layoverTime && (
                                <div className="text-sm text-gray-600 mb-2">
                                    <span className="font-medium">Layover: </span>{segment.layoverTime}
                                </div>
                            )} */}

                            {/* <div className="text-sm text-gray-500">
                                <span className="font-medium">Luggage: </span>
                                {segment.luggageInfo.quantity} Bag(s), {segment.luggageInfo.weight} {segment.luggageInfo.weightUnit || "kg"}
                            </div> */}
                        </div>


                    </div>
                ))}
            </div>
        </div>
    );
};

export default FlightCard;
